import React from 'react';
import styles from './AboutUsMission.module.scss';

const AboutUsMission = () => {
    return (
        <section className={styles.section}>
            <div className={styles.contentWrapper}>
                <span className={styles.label}>WHO'S BEHIND PREPAL</span>
                <h2 className={styles.heading}>Prepal Was Built to Fix This</h2>
                <p className={styles.subheading}>
                    We combined our experience as top-tier tutors with advanced AI to give every student
                    a personalized 1500+ scorer in their pocket.
                </p>
                <div className={styles.founderCard}>
                    <div className={styles.avatarWrapper}>
                        <img
                            src="https://res.cloudinary.com/deqwgnw98/image/upload/v1774694770/Prepal_Profile_Photo_2_whyw4j.png"
                            alt="Khoa V."
                            className={styles.avatar}
                        />
                    </div>
                    <div className={styles.founderInfo}>
                        <div className={styles.founderHeader}>
                            <span className={styles.founderName}>Khoa V.</span>
                            <span className={styles.founderBadge}>FOUNDER &amp; PRODUCT LEAD</span>
                        </div>
                        <p className={styles.founderQuote}>
                            "I've built and operated an SAT tutoring agency for 3 years, helping 100+ students.
                            I understand the parental struggle and student archetypes deeply.
                            Prepal is the tool I wish I could have given my students."
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutUsMission;
